import t from '@/i18n';
import factory from './api/factory';

export default async (to, from, next) => {
  try {
    await factory('confirm_email').create({ hash: to.params.hash });
    alert(t('Email has been successfully confirmed'));
    next({ name: 'login' });
  } catch (e) {
    alert(t('Confirmation code is invalid'));
    next({ name: 'register' });
  }
};
